import { Injectable } from '@angular/core';

import { RedirectCommand } from './redirect-command';
import { RedirectStrategy } from './redirect-strategy';

@Injectable({ providedIn: 'root' })
export class DefaultRedirectStrategy implements RedirectStrategy {
    async execute(): Promise<RedirectCommand> {
        return { path: '' };
    }

    strategyName(): string {
        return 'default';
    }
}
